export const LOGIN = 'LOGIN/LOGIN';
export const LOGIN_SUCCESS = 'LOGIN/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN/LOGIN_ERROR';
export const RESTORE_PASSWORD = 'LOGIN/RESTORE_PASSWORD';
export const RESTORE_PASSWORD_SUCCESS = 'LOGIN/RESTORE_PASSWORD_SUCCESS';
export const RESTORE_PASSWORD_ERROR = 'LOGIN/RESTORE_PASSWORD_ERROR';
export const SET_FIELD = 'LOGIN/SET_FIELD';
export const SET_TOKENS = 'LOGIN/SET_TOKENS';
export const CLEAR_TOKENS = 'LOGIN/CLEAR_TOKENS';
export const SET_REDIRECT = 'LOGIN/SET_REDIRECT';
export const SET_CXML_DATA = 'LOGIN/SET_CXML_DATA';
export const SET_PLATFORM_TYPE = 'LOGIN/SET_PLATFORM_TYPE';
export const CLEAR_PLATFORM_TYPE = 'LOGIN/CLEAR_PLATFORM_TYPE';